import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import LocalStorage from "@probatix/common/utils/localStorage"
import { EXPIRY_OF_JWT_TOKEN_MINUTES } from "@probatix/common/config/app"
import { EXPIRATION_TIME_JWT, JWT } from '@probatix/common/services/services.constants'

interface SessionTokenState {
  expiry: number
  token: string | null
}

const initialState: SessionTokenState = {
  expiry: LocalStorage.get(EXPIRATION_TIME_JWT) ? Number(LocalStorage.get(EXPIRATION_TIME_JWT)) : 0,
  token: LocalStorage.get(JWT) || null,
}

export default createSlice({
  initialState,
  name: "sessionToken",
  reducers: {
    clearToken: (state) => {
      state.token = null
      state.expiry = 0
      LocalStorage.remove(JWT)
      LocalStorage.remove(EXPIRATION_TIME_JWT)
    },
    setToken(state, action: PayloadAction<string>) {
      const lastToken = action.payload
      const expiry = Date.now() + 1000 * 60 * Number(EXPIRY_OF_JWT_TOKEN_MINUTES)
      state.token = action.payload
      state.expiry = expiry
      LocalStorage.set(JWT, lastToken)
      LocalStorage.set(EXPIRATION_TIME_JWT, expiry)
    },
  },
})
